export default __webpack_public_path__ + "static/media/background.50963673.png";